import React, { useState } from "react"
import { EditUserFormTextField } from "./EditUserFormTextField"

interface User {
  id: number
  last_name: string
}

interface LastNameFieldProps {
  user: User
}

export const LastNameField: React.FC<LastNameFieldProps> = ({ user }) => {
  const [value, setValue] = useState(user.last_name || "")

  const fieldData = {
    field: "last_name",
    name: "last_name",
    label: "Last Name",
    placeholder: "Enter your real last name",
    required: true,
  }

  return (
    <>
      <EditUserFormTextField
        fieldData={fieldData}
        value={value}
        setValue={setValue}
        userId={user.id}
      />
    </>
  )
}
